import { echoService } from '@/app/core/services/echo.service';
import { createEchoObservable } from '@fifa-bsm/bo-frontend-shared/utils/rxjs';
import { filter, share, takeUntil } from 'rxjs';
import { filterByEventNames } from '@fifa-bsm/bo-frontend-shared/utils/rxjs';
import { bufferDebounce } from '@fifa-bsm/bo-frontend-shared/utils/rxjs';
import { uniqueValues } from '@fifa-bsm/bo-frontend-shared/utils';
import { pipe } from '@fifa-bsm/bo-frontend-shared/utils';
import { clearProgressToast } from '@/app/shared/utils/importParticipantsToast';

const echoEvents = {
    private: {
        TicketCancellationFailed:
            '.App\\Events\\SeatAllocation\\GuestOperations\\TicketCancellationFailed',
        ParticipantsImportedFromXlsxFile: 'MainEvent\\ParticipantsImportedFromXlsxFile',
        ParticipantsImportFromXlsxFileValidationError:
            'MainEvent\\ParticipantsImportFromXlsxFileValidationError',
        ParkingPassesExceededTicketsNumber:
            'App\\Events\\GuestOperations\\ParkingPassesExceededTicketsNumber',
    },
    seatAllocator: {
        ETicketDistributionRolledBack:
            'SeatAllocation\\GuestOperations\\DistributionHasBeenRolledBack',
    },
};
const getEchoEventsToSubscribeTo = (user) => {
    const privateChannel = `User.${user.id}`;

    return {
        [privateChannel]: echoEvents.private,
        'SeatAllocator.GuestOperations': echoEvents.seatAllocator,
    };
};

export const listenForGlobalEchoEvents = ({ user, toasted, t, destroy$ }) => {
    Object.entries(getEchoEventsToSubscribeTo(user) ?? {}).forEach(([channelName, events]) => {
        const eventNames = Object.values(events);
        if (eventNames.length === 0) {
            return;
        }

        const echoChannel = echoService.private(channelName);
        const events$ = createEchoObservable(echoChannel, Object.values(events)).pipe(
            share(),
            takeUntil(destroy$)
        );

        events$
            .pipe(filterByEventNames(echoEvents.private.TicketCancellationFailed))
            .subscribe((event) => {
                toasted.show(event.warning, { duration: null, type: 'warning' });
            });

        events$
            .pipe(filterByEventNames(echoEvents.private.ParkingPassesExceededTicketsNumber))
            .subscribe((event) => {
                toasted.show(event.warning, { duration: null, type: 'warning' });
            });

        events$
            .pipe(filterByEventNames(echoEvents.private.ParticipantsImportedFromXlsxFile))
            .subscribe(() => {
                clearProgressToast();
                toasted.show(t('lang_bookings.PARTICIPANTS_IMPORTED_SUCCESS'), {
                    type: 'success',
                    duration: null,
                });
            });

        events$
            .pipe(
                filterByEventNames(echoEvents.private.ParticipantsImportFromXlsxFileValidationError)
            )
            .subscribe((event) => {
                clearProgressToast();
                const errorMessages = Object.entries(event.errors)
                    .map(([field, messages]) => {
                        const match = field.match(/^(\d+)\./);
                        const rowIndex = match ? parseInt(match[1], 10) + 2 : '?';
                        return `Row ${rowIndex}: ${messages.join(', ')}`;
                    })
                    .join('\n');

                toasted.show(
                    t('lang_bookings.PARTICIPANTS_IMPORT_VALIDATION_ERROR').toString() +
                        ': ' +
                        errorMessages,
                    { type: 'error', duration: null }
                );
            });

        events$
            .pipe(
                filterByEventNames(echoEvents.private.ETicketDistributionRolledBack),
                filter((event) => event.distributed_by_user_id === user.id),
                bufferDebounce(5000)
            )
            .subscribe((bufferedEvents) => {
                const matchNumbers = pipe(
                    (_events) => _events.map((event) => event.match_number),
                    uniqueValues,
                    (_matchNumbers) => _matchNumbers.join(', ')
                )(bufferedEvents);

                toasted.show(
                    t('lang_seating.TICKETS_HAVE_BEEN_ROLLED_BACK', {
                        matchNumbers,
                    }).toString(),
                    { type: 'warning' }
                );
            });

        events$
            .pipe(
                filterByEventNames(echoEvents.seatAllocator.ETicketDistributionRolledBack),
                filter((event) => event.distributed_by_user_id === user.id),
                bufferDebounce(5000)
            )
            .subscribe((bufferedEvents) => {
                const matchNumbers = pipe(
                    (_events) => _events.map((event) => event.match_number),
                    uniqueValues,
                    (_matchNumbers) => _matchNumbers.join(', ')
                )(bufferedEvents);

                toasted.show(
                    t('lang_seating.TICKETS_HAVE_BEEN_ROLLED_BACK', {
                        matchNumbers,
                    }).toString(),
                    { type: 'warning' }
                );
            });
    });
};
